/**
 * Dokumentation (/dokumentation): Online-Benutzerhandbuch mit Kapitel-
 * Navigation, Volltextsuche, teilbaren Anker-Links und FAQ.
 * Inhalte: src/docs/inhalte.ts (Quelle: docs/PRD.md + docs/features/*.md).
 */

import { BookOpen } from "lucide-react"
import { DocsLayout } from "@/components/docs/DocsLayout"
import { HANDBUCH } from "@/docs/inhalte"

export function DokumentationPage() {
  return (
    <div className="space-y-4">
      <div>
        <h1 className="flex items-center gap-2 text-2xl font-semibold tracking-tight">
          <BookOpen className="h-6 w-6" />
          Dokumentation
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Benutzerhandbuch der Personalapp — Anleitungen, Rollen-Hinweise und FAQ. Tipp: Das
          „?“-Symbol in der Kopfzeile springt direkt zum Kapitel der aktuellen Seite; jeder
          Abschnitt ist über seinen Anker-Link teilbar.
        </p>
      </div>
      <DocsLayout kapitel={HANDBUCH} />
    </div>
  )
}
